import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import "react-slideshow-image/dist/styles.css";
import { useEffect, useRef, useState } from "react";
import axios from "../api/axios";
import FlexRow from "../components/FlexRow";
import FlexColumn from "../components/FlexColumn";
import useAuth from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import "react-slideshow-image/dist/styles.css";
import { MOBILE } from "../Constants";

import { isAuthEmpty } from "../utils/isAuthEmpty";
import { Helmet } from "react-helmet";
import validatePhone from "../utils/validatePhone";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 5.75rem);
  background: ${({ theme }) => theme.grayScaleColor.white};
  // border: 1px solid black;
`;

const Heading1 = styled.h2`
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 700;
  line-height: 160%; /* 2rem */
  letter-spacing: -0.03125rem;
  color: ${({ theme }) => theme.grayScaleColor.black};
`;

const Heading2 = styled.h2`
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 1.225rem */
  letter-spacing: -0.03125rem;
  color: ${({ theme }) => theme.grayScaleColor.gray80};
`;

const Heading3 = styled.h3`
  color: #000;
  text-align: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 1.6rem */
  letter-spacing: -0.03125rem;
  margin-top: 2.56rem;
  margin-bottom: 1.25rem;
`;

const Heading4 = styled.h4`
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; /* 1.4rem */
  letter-spacing: -0.03125rem;
  color: ${({ theme }) => theme.backgroundColor.darkgray40};
`;

const Section = styled.section`
  padding: 1.75rem 1.25rem;
`;

const CashContainer = styled.div`
  padding: 1rem 1.25rem;
  margin-top: 1.75rem;
  border-radius: 0.625rem;
  border: 1px solid ${({ theme }) => theme.backgroundColor.darkgray10};
  background: ${({ theme }) => theme.backgroundColor.darkgray10};
  display: flex;
  justify-content: space-between;
  align-items: center;
  & .cash {
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    color: #000;
  }
`;

const Text5 = styled.p`
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 1.225rem */
  letter-spacing: -0.03125rem;
  color: ${({ theme }) => theme.grayScaleColor.black};
`;

const Box = styled.div`
  border-radius: 0.625rem;
  border: 1px solid
    ${({ theme, disabled }) =>
      disabled ? theme.grayScaleColor.gray10 : theme.grayScaleColor.gray20};
  background: ${({ theme, disabled }) =>
    disabled && theme.grayScaleColor.gray5};
  padding: 1.25rem;
  color: ${({ theme, disabled }) =>
    disabled ? theme.grayScaleColor.gray30 : theme.grayScaleColor.black};
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 1.5rem */
  letter-spacing: -0.03125rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Chevron = ({ fill = "#5F6368" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.2921 12L8.69214 7.40001L9.39989 6.69226L14.7076 12L9.39989 17.3078L8.69214 16.6L13.2921 12Z"
        fill={fill}
      />
    </svg>
  );
};

function MypageReward() {
  const { auth, setAuth } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      // console.log(response.data.surveys);
      setIsLoading(false);
    };

    if (isAuthEmpty(auth)) {
      return navigate("/login");
    }
    fetch();
  }, []);
  // console.log(surveyYearMonth, monthPeriod);
  if (isLoading) {
    return <div />;
  }

  return (
    <Container>
      <Helmet>
        <meta name="theme-color" content="#fff" />
      </Helmet>
      <Section>
        <Heading1 style={{ marginBottom: "0.5rem" }}>환급 신청</Heading1>
        <Heading4>보유한 캐시를 원하는 방식으로 환급 받을 수 있어요.</Heading4>
        <CashContainer>
          <Text5>보유 캐시</Text5>
          <FlexRow style={{ alignItems: "center", gap: "0.25rem" }}>
            <img
              style={{ width: "1rem", height: "1rem" }}
              src={`${process.env.PUBLIC_URL}/assets/icons/cash_icon.png`}
              alt="cash icon"
            />
            <p className="cash">{auth.user.point.toLocaleString()}원</p>
          </FlexRow>
        </CashContainer>
        <Text5 style={{ marginTop: "2.5rem", fontWeight: 500, color: "#222" }}>
          환급 방식 선택
        </Text5>
        <FlexColumn style={{ gap: "1rem", marginTop: "1rem" }}>
          <Box onClick={() => navigate("withdraw")}>
            <FlexRow style={{ gap: "0.75rem", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5 17V19V5V17ZM5.6155 20C5.168 20 4.78683 19.8427 4.472 19.528C4.15733 19.2132 4 18.832 4 18.3845V5.6155C4 5.168 4.15733 4.78683 4.472 4.472C4.78683 4.15733 5.168 4 5.6155 4H18.3845C18.832 4 19.2132 4.15733 19.528 4.472C19.8427 4.78683 20 5.168 20 5.6155V8.55775H19V5.6155C19 5.436 18.9423 5.2885 18.827 5.173C18.7115 5.05767 18.564 5 18.3845 5H5.6155C5.436 5 5.2885 5.05767 5.173 5.173C5.05767 5.2885 5 5.436 5 5.6155V18.3845C5 18.564 5.05767 18.7115 5.173 18.827C5.2885 18.9423 5.436 19 5.6155 19H18.3845C18.564 19 18.7115 18.9423 18.827 18.827C18.9423 18.7115 19 18.564 19 18.3845V15.4423H20V18.3845C20 18.832 19.8427 19.2132 19.528 19.528C19.2132 19.8427 18.832 20 18.3845 20H5.6155ZM13.6155 16C13.168 16 12.7868 15.8427 12.472 15.528C12.1573 15.2132 12 14.832 12 14.3845V9.6155C12 9.168 12.1573 8.78683 12.472 8.472C12.7868 8.15733 13.168 8 13.6155 8H19.3845C19.832 8 20.2132 8.15733 20.528 8.472C20.8427 8.78683 21 9.168 21 9.6155V14.3845C21 14.832 20.8427 15.2132 20.528 15.528C20.2132 15.8427 19.832 16 19.3845 16H13.6155ZM19.3845 15C19.564 15 19.7115 14.9423 19.827 14.827C19.9423 14.7115 20 14.564 20 14.3845V9.6155C20 9.436 19.9423 9.2885 19.827 9.173C19.7115 9.05767 19.564 9 19.3845 9H13.6155C13.436 9 13.2885 9.05767 13.173 9.173C13.0577 9.2885 13 9.436 13 9.6155V14.3845C13 14.564 13.0577 14.7115 13.173 14.827C13.2885 14.9423 13.436 15 13.6155 15H19.3845ZM16 13.5C16.4167 13.5 16.7708 13.3542 17.0625 13.0625C17.3542 12.7708 17.5 12.4167 17.5 12C17.5 11.5833 17.3542 11.2292 17.0625 10.9375C16.7708 10.6458 16.4167 10.5 16 10.5C15.5833 10.5 15.2292 10.6458 14.9375 10.9375C14.6458 11.2292 14.5 11.5833 14.5 12C14.5 12.4167 14.6458 12.7708 14.9375 13.0625C15.2292 13.3542 15.5833 13.5 16 13.5Z"
                  fill="#5F6368"
                />
              </svg>

              <p>현금 이체</p>
            </FlexRow>
            <Chevron />
          </Box>
          <Box disabled={true}>
            <FlexRow style={{ gap: "0.75rem", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4.23075 21V10.2307H3V5.8077H8.14225C7.94358 5.63204 7.80608 5.42362 7.72975 5.18245C7.65358 4.94145 7.6155 4.68829 7.6155 4.42295C7.6155 3.76062 7.84733 3.19762 8.311 2.73395C8.77467 2.27029 9.33767 2.03845 10 2.03845C10.3833 2.03845 10.7353 2.12854 11.0558 2.3087C11.3763 2.4887 11.6525 2.72295 11.8845 3.01145C12.1167 2.71912 12.393 2.48387 12.7135 2.3057C13.034 2.12754 13.3859 2.03845 13.7693 2.03845C14.4316 2.03845 14.9946 2.27029 15.4583 2.73395C15.9219 3.19762 16.1538 3.76062 16.1538 4.42295C16.1538 4.68329 16.1147 4.93429 16.0365 5.17595C15.9583 5.41762 15.8218 5.6282 15.627 5.8077H21V10.2307H19.7693V21H4.23075ZM13.7693 3.03845C13.3769 3.03845 13.0481 3.17112 12.7828 3.43645C12.5173 3.70179 12.3845 4.03062 12.3845 4.42295C12.3845 4.81529 12.5173 5.14412 12.7828 5.40945C13.0481 5.67495 13.3769 5.8077 13.7693 5.8077C14.1616 5.8077 14.4904 5.67495 14.7557 5.40945C15.0211 5.14412 15.1538 4.81529 15.1538 4.42295C15.1538 4.03062 15.0211 3.70179 14.7557 3.43645C14.4904 3.17112 14.1616 3.03845 13.7693 3.03845ZM8.6155 4.42295C8.6155 4.81529 8.74817 5.14412 9.0135 5.40945C9.27883 5.67495 9.60767 5.8077 10 5.8077C10.3923 5.8077 10.7212 5.67495 10.9865 5.40945C11.2518 5.14412 11.3845 4.81529 11.3845 4.42295C11.3845 4.03062 11.2518 3.70179 10.9865 3.43645C10.7212 3.17112 10.3923 3.03845 10 3.03845C9.60767 3.03845 9.27883 3.17112 9.0135 3.43645C8.74817 3.70179 8.6155 4.03062 8.6155 4.42295ZM4 6.8077V9.2307H11.5V6.8077H4ZM11.5 20V10.2307H5.23075V20H11.5ZM12.5 20H18.7693V10.2307H12.5V20ZM20 9.2307V6.8077H12.5V9.2307H20Z"
                  fill="#BBBBBB"
                />
              </svg>
              <p>맘핏 굿즈</p>
            </FlexRow>
            <Chevron fill="#BBBBBB" />
          </Box>
          <Box disabled={true}>
            <FlexRow style={{ gap: "0.75rem", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M15.6923 12.3845L11.9271 8.777C11.4872 8.35383 11.1202 7.8805 10.8261 7.357C10.5317 6.83333 10.3846 6.26308 10.3846 5.64625C10.3846 4.91108 10.6419 4.28625 11.1566 3.77175C11.6711 3.25725 12.2958 3 13.0308 3C13.577 3 14.0738 3.14775 14.5213 3.44325C14.9686 3.73875 15.359 4.09742 15.6923 4.51925C16.0256 4.09742 16.4161 3.73875 16.8636 3.44325C17.3109 3.14775 17.8076 3 18.3538 3C19.089 3 19.7138 3.25725 20.2283 3.77175C20.7428 4.28625 21.0001 4.91108 21.0001 5.64625C21.0001 6.26308 20.8539 6.83333 20.5616 7.357C20.2692 7.8805 19.9032 8.35383 19.4636 8.777L15.6923 12.3845ZM15.6923 11.0078L18.6866 8.1405C19.0417 7.79817 19.3494 7.419 19.6096 7.003C19.8699 6.58683 20.0001 6.13458 20.0001 5.64625C20.0001 5.18975 19.8398 4.80125 19.5193 4.48075C19.1988 4.16025 18.8103 4 18.3538 4C17.9538 4 17.5952 4.11958 17.2781 4.35875C16.9607 4.59775 16.6757 4.87942 16.4231 5.20375L15.6923 6.11925L14.9616 5.20375C14.7091 4.87942 14.4241 4.59775 14.1068 4.35875C13.7895 4.11958 13.4308 4 13.0308 4C12.5745 4 12.1861 4.16025 11.8656 4.48075C11.5449 4.80125 11.3846 5.18975 11.3846 5.64625C11.3846 6.13458 11.5147 6.58683 11.7751 7.003C12.0354 7.419 12.3431 7.79817 12.6981 8.1405L15.6923 11.0078ZM6.40381 18.6538L13.9693 20.8615L19.9578 19.0115C19.9385 18.7077 19.8477 18.4888 19.6856 18.3548C19.5232 18.2207 19.3396 18.1538 19.1346 18.1538H14.3901C13.9672 18.1538 13.5841 18.1371 13.2406 18.1038C12.8969 18.0704 12.5449 17.991 12.1846 17.8655L9.99431 17.148L10.3328 16.1595L12.3578 16.8923C12.6796 17.0141 13.045 17.0872 13.4538 17.1115C13.8628 17.1358 14.4231 17.1499 15.1346 17.1538C15.1346 16.8423 15.0772 16.5903 14.9626 16.398C14.8479 16.2057 14.6835 16.0717 14.4693 15.9962L8.71556 13.8845C8.67706 13.8718 8.64173 13.8623 8.60956 13.8558C8.57756 13.8494 8.54231 13.8463 8.50381 13.8463H6.40381V18.6538ZM2.40381 21V12.8463H8.48131C8.57464 12.8463 8.67064 12.8567 8.76931 12.8777C8.86798 12.8989 8.95964 12.9237 9.04431 12.952L14.8231 15.0693C15.1807 15.2051 15.4887 15.4493 15.7471 15.802C16.0054 16.1545 16.1346 16.6051 16.1346 17.1538H19.1346C19.7372 17.1538 20.1988 17.3423 20.5193 17.7193C20.8398 18.0961 21.0001 18.5743 21.0001 19.1538V19.7693L14.0193 21.923L6.40381 19.7038V21H2.40381ZM3.40381 20H5.40381V13.8463H3.40381V20Z"
                  fill="#BBBBBB"
                />
              </svg>
              <p>기부하기</p>
            </FlexRow>
            <Chevron fill="#BBBBBB" />
          </Box>
        </FlexColumn>
      </Section>
    </Container>
  );
}

export default MypageReward;
